import { render } from "./signature-double-authentification.vue?vue&type=template&id=3f25cb10"
import script from "./signature-double-authentification.vue?vue&type=script&lang=js"
export * from "./signature-double-authentification.vue?vue&type=script&lang=js"

import "./signature-double-authentification.vue?vue&type=style&index=0&id=3f25cb10&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__